<template>
  <li :data-nid="item.nid" class="btn-hover-parent">
    <a
      :href="item.url"
      class="offer flex link text-normal pdgv- md-pdgv+"
      :class="classes"
    >
      <div class="offer__time">
        <div class="text-h4 _text-medium" v-html="timeFrom"></div>
        <div class="text-muted text-tiny">
          <span>bis</span>&nbsp;<span v-html="timeTo"></span>
        </div>
      </div>

      <div class="offer__content">
        <div class="offer__title">
          <h4 class="text-bold">
            <span>{{ item.sport }}</span>
          </h4>
          <div class="text-muted text-tiny">
            {{ item.title }}, {{ item.niveau }}
          </div>
        </div>

        <div class="offer__info">
          <div class="offer__location text-h4 _text-light">
            {{ facility }}
          </div>
          <div
            v-if="item.location && item.facilities.length === 0"
            class="offer__location text-h4 _text-light"
          >
            {{ item.location }}
          </div>
          <div class="offer__instructors text-tiny text-muted text-ellipsis">
            {{ instructors }}
          </div>
        </div>
      </div>
      <div
        v-if="item.livestream"
        class="offer__livestream"
        title="Livestream verfügbar"
      >
        <div class="btn btn--primary offer__livestream-btn">
          <icon icon-id="play" />
        </div>
      </div>

      <div v-if="item.status !== STATUS.DEFAULT" class="offer__actions">
        <actions :item="item"></actions>
      </div>
    </a>
  </li>
</template>

<script>
import { withLeading } from '@/tools/date'
import Item from './Item'
import Icon from '@/components/Ui/Icon'

export default {
  components: {
    Icon
  },
  extends: Item,

  props: {
    active: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes: function () {
      let classes = []

      if (this.active) {
        classes.push('active')
      }

      if (this.loading) {
        classes.push('loading')
      }

      return classes
    },
    timeFrom: function () {
      return `${this.item.timespan.from.hours}:${this.item.timespan.from.minutes}`
    },
    timeTo: function () {
      if (this.item.timespan.isOneDay) {
        return `${this.item.timespan.to.hours}:${this.item.timespan.to.minutes}`
      } else {
        return [
          withLeading(this.item.timespan.to.date),
          withLeading(this.item.timespan.to.month),
          this.item.timespan.to.year.toString().substring(2, 4)
        ].join('.')
      }
    },
    instructors: function () {
      let string = this.item.instructors.slice(0, 7).join(', ')
      if (this.item.instructors.length > 7) {
        string += ', ...'
      }
      return string
    },
    facility: function () {
      return this.item.facilities
        .map((v) => {
          return v.name
        })
        .join(',')
    }
  },

  mounted() {}
}
</script>
